var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 75,
  height: 33,
  fill: "none",
  viewBox: "0 0 75 33"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M2.942 27.883C2.497 20.973 6.858 6.406 27.86 3.418 54.113-.317 65.263 22.02 68.823 28.431m-8.29.2L70.896 30l1.017-10.21"
})));
export { SvgArrowHorizontal as ReactComponent };